<template>
    <p
        class="mb-8 whitespace-pre-line px-2 text-[1rem] leading-[1.8] sm:px-5 lg:text-[1.25rem]"
    >
        <slot />
    </p>
</template>
